"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetricsConfiguration_1 = require("./_MetricsConfiguration");
exports.PutBucketMetricsConfigurationInput = {
    type: "structure",
    required: ["Bucket", "Id", "MetricsConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Id: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "id"
        },
        MetricsConfiguration: {
            shape: _MetricsConfiguration_1._MetricsConfiguration,
            locationName: "MetricsConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "MetricsConfiguration"
};
//# sourceMappingURL=PutBucketMetricsConfigurationInput.js.map